import React, { useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { LoginScreen }          from '../Component/login/LoginScreen';
import { ResetPasswordScreen }  from '../Component/login/ResetPasswordScreen';
import { recuperarLoginActionAxios } from '../actions/auth';
import { PrivateRoute }   from './PrivateRoute';
import { DashboardRoutes } from './DashboardRoutes';
import { PublicRoute }    from './PublicRoute';

export const AppRouter = () => {
    const dispatch = useDispatch();
    const [fiRevisarSessio,     setFiRevisarSessio]     = useState(false);
    const [estaRecuperacioLogin, setEstatRecuperacioLogin] = useState(false);
    const [loginat, setLoginat] = useState(false);
    const { auth } = useSelector(state => state);

    useEffect(() => {
        dispatch(recuperarLoginActionAxios());
        setFiRevisarSessio(true);
        setEstatRecuperacioLogin(false);
    }, []);

    if (fiRevisarSessio === false) {
        return <h1>Estem revisant si existeix una sessió iniciada prèviament...</h1>;
    }

    if (auth.tokenJwt !== undefined && !estaRecuperacioLogin) {
        setEstatRecuperacioLogin(true);
        setLoginat(true);
    }

    return (
        <BrowserRouter>
            <Routes>
                {/* Ruta pública: login */}
                <Route path="/login/*" element={
                    <PublicRoute>
                        <LoginScreen estaLoginat={loginat} />
                    </PublicRoute>
                } />

                {/* Ruta pública: reset/activar contraseña (no requiere login) */}
                <Route path="/reset-password" element={<ResetPasswordScreen />} />

                {/* Rutas privadas */}
                <Route path="/*" element={
                    <PrivateRoute estaLoginat={loginat}>
                        <DashboardRoutes />
                    </PrivateRoute>
                } />
            </Routes>
        </BrowserRouter>
    );
};
